import { SideImage } from '../../components/SideImage';
import { StickyFooter } from '../../components/StickyFooter';
import { GolfPlayersContent } from '../../composites/GolfPlayersContent';
import { SplitLayout } from '../../composites/SplitLayout';
import type { GolfPlayersTemplateProps } from './GolfPlayersTemplate.types';

export function GolfPlayersTemplate({
  imageUrl,
  imageAlt,
  onBack,
  stickyFooter,
  labels,
  ...contentProps
}: GolfPlayersTemplateProps) {
  const { stickyFooter: stickyFooterLabels, backLabel, ...contentLabels } = labels ?? {};

  return (
    <SplitLayout
      left={
        <SideImage src={imageUrl} alt={imageAlt} sticky onBack={onBack} backLabel={backLabel} />
      }
      right={
        <>
          <GolfPlayersContent {...contentProps} labels={contentLabels} />
          {stickyFooter && (
            <StickyFooter
              {...stickyFooter}
              totalLabel={stickyFooterLabels?.totalLabel}
              ctaLabel={stickyFooterLabels?.ctaLabel ?? 'Add to basket'}
            />
          )}
        </>
      }
      contentGap="0px"
      contentMaxWidth="100%"
      hideLeftOnMobile
    />
  );
}
